document.addEventListener('turbolinks:load', () => {

  var item_thumbnail_change = document.getElementById('thumbnail_change_item')
  
  var file_field = document.getElementById('item_images');

  if(item_thumbnail_change){  
    $('input[type=file]').change(function() {
      // console.log("png_uploaded");
      var file = $(this).prop('files')[0];
      if (! file.type.match('image.*')) {
        $(this).val('');
        $('span').html('');
        return;
      }else{

        // file_field.append(file)

      }
      
      // console.log(file.type)
      // 画像表示
      var reader = new FileReader();
      reader.onload = function() {
        var img_src = $('<img>').attr('src', reader.result);
        $('#thumbnail_change_item').html(img_src);
        
        var imgWidth = img_src.width();
        var imgHeight = img_src.height();        
        var aspectRatio = imgWidth / imgHeight
      
        if(aspectRatio >= 1){
          img_src.css('height','200px');
        }else{
          img_src.css('width','300px');
    
          var i = (imgHeight-200)/2 
          $(this).find('img').css('margin-top', '-'+i+'px');
        }

      }
      reader.readAsDataURL(file);
    });
  }


  var sale_el = document.getElementById('sale_thumbnail_change')
  // console.log(el)
  if(sale_el){
    // アップロードするファイルを選択
    $('input[type=file]').change(function() {
      var file = $(this).prop('files')[0];
      var img = document.getElementById("sale_thumbnail_change");
      // 画像以外は処理を停止
      if (! file.type.match('image.*')) {
        // クリア
        $(this).val('');
        $('span').html('');
        return;
      }

      // 画像表示
      var reader = new FileReader();
      reader.onload = function() {
        // var img_src = $('<img>').attr('src', reader.result);
        // $('span').html(img_src);
        img.width = '200';
        img.src = reader.result
      }
      reader.readAsDataURL(file);
    });
  }


});